import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const degreesOfFreedomDescription: CalculatorDescription = {
  id: CalculatorId.DEGREES_OF_FREEDOM,
  title: 'Degrees of Freedom Calculator',
  metaTitle: 'Degrees of Freedom Calculator - Statistical Analysis Tool',
  description: 'Calculate degrees of freedom for various statistical tests including t-tests, ANOVA, and chi-square tests',
  metaDescription: 'Use our degrees of freedom calculator to determine the appropriate degrees of freedom for t-tests, ANOVA, chi-square, and other statistical analyses.',
  howTo: {
    title: 'How to use the Degrees of Freedom Calculator',
    steps: [
      'Select the type of statistical test from the dropdown menu',
      'Enter the required parameters based on your selected test type',
      'View the calculated degrees of freedom along with the formula used and explanation',
      'Use the result in your statistical hypothesis testing or confidence interval calculations'
    ]
  },
  examples: [
    {
      title: 'Degrees of Freedom for a Sample',
      description: 'When analyzing a single sample, the degrees of freedom is n - 1',
      dataDescription: 'A study collected test scores from 30 students',
      insights: [
        'The degrees of freedom would be 30 - 1 = 29',
        'This value would be used in t-tests and confidence interval calculations'
      ]
    },
    {
      title: 'Degrees of Freedom for ANOVA',
      description: 'Between-groups degrees of freedom is k - 1, where k is the number of groups',
      dataDescription: 'A researcher comparing 4 different treatment groups',
      insights: [
        'The between-groups degrees of freedom would be 4 - 1 = 3',
        'This affects the critical F-value used to determine statistical significance'
      ]
    },
    {
      title: 'Degrees of Freedom for Chi-Square',
      description: 'In a contingency table, degrees of freedom is (rows - 1) × (columns - 1)',
      dataDescription: 'A 3×4 table comparing gender and education levels',
      insights: [
        'The degrees of freedom would be (3 - 1) × (4 - 1) = 2 × 3 = 6',
        'This value determines the critical chi-square value for the hypothesis test'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.CRITICAL_VALUE,
    CalculatorId.CONFIDENCE_INTERVAL,
    CalculatorId.CHI_SQUARE,
    CalculatorId.ANOVA
  ]
}; 